import { render, staticRenderFns } from "./InvoiceTableItemSkeletonMobile.vue?vue&type=template&id=54e0e30c&scoped=true"
import script from "./InvoiceTableItemSkeletonMobile.vue?vue&type=script&lang=js"
export * from "./InvoiceTableItemSkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTableItemSkeletonMobile.vue?vue&type=style&index=0&id=54e0e30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0e30c",
  null
  
)

export default component.exports